// src/hooks/useAlarmes.js - Versão atualizada (substituir o arquivo existente)
import { useState, useCallback, useEffect } from "react";
import { getAlarmes } from "../API/basic/getAlarmes";

const TIMEOUT_MS = 3500;
const POLL_MS = 5000;
const fetchComTimeout = (ms, prom) =>
  Promise.race([
    prom,
    new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms)),
  ]);

export default function useAlarmes() {
  const [caixas, setCaixas] = useState([]);
  const [bombas, setBombas] = useState([]);
  const [status, setStatus] = useState("ok");
  const [alarmActive, setAlarmActive] = useState(false);
  const [tipoAlarmeAtivo, setTipoAlarmeAtivo] = useState(null); // ✨ Nova funcionalidade

  const determinarTipoAlarme = useCallback((caixasData, bombasData) => {
    // Verifica se há alarme em caixas d'água
    const temAlarmeCaixa = caixasData.some((item) => Boolean(item.disparar));
    
    // Verifica se há alarme em bombas
    const temAlarmeBomba = bombasData.some((item) => Boolean(item.disparar));

    // Determina qual tipo de alarme está ativo
    if (temAlarmeCaixa && temAlarmeBomba) {
      // Se ambos têm alarme, prioriza caixas d'água (você pode ajustar)
      return "CaixaDAgua";
    } else if (temAlarmeCaixa) {
      return "CaixaDAgua";
    } else if (temAlarmeBomba) {
      return "Bombas";
    }
    
    return null;
  }, []);

  const carregarAlarmes = useCallback(async () => {
    try {
      const data = await fetchComTimeout(TIMEOUT_MS, getAlarmes());
      const rawCaixas = Array.isArray(data[0]) ? data[0] : [];
      const rawBombas = Array.isArray(data[1]) ? data[1] : [];

      // atualiza arrays (clonando pra garantir nova referência)
      setCaixas([...rawCaixas]);
      setBombas([...rawBombas]);

      // decide se há alarme
      const temAlarme = [...rawCaixas, ...rawBombas].some(
        (item) => Boolean(item.disparar)
      );
      
      setAlarmActive(temAlarme);

      // ✨ Determina o tipo específico de alarme
      if (temAlarme) {
        const tipoDetectado = determinarTipoAlarme(rawCaixas, rawBombas);
        setTipoAlarmeAtivo(tipoDetectado);
      } else {
        setTipoAlarmeAtivo(null);
      }

      setStatus("ok");
    } catch (err) {
      console.error("Falha ao buscar alarmes:", err);
      setStatus("error");
      setAlarmActive(false);
      setTipoAlarmeAtivo(null);
    }
  }, [determinarTipoAlarme]);

  useEffect(() => {
    carregarAlarmes();
    const id = setInterval(carregarAlarmes, POLL_MS);
    return () => clearInterval(id);
  }, [carregarAlarmes]);

  return { 
    caixas, 
    bombas, 
    status, 
    alarmActive, 
    tipoAlarmeAtivo // ✨ Nova propriedade retornada
  };
}